export default __webpack_public_path__ + "static/media/3_CP_Next.86d4b3b2.png";